export default __webpack_public_path__ + "static/media/Group 1374.b63ab1c5.png";